import { authHttp } from '../http'
import { errorHandler } from '../../../util/error.service'
import { CONFIG } from '../../../../config'
import { parseToMysqlFormatWithTime } from '../../../util/date.service'

const { ENVIROMENT } = CONFIG
const BASE_URL = `${CONFIG[ENVIROMENT]['MAIN_END_POINT']}/delivery`

const MultiDeliveryCycleHttp = {
  async save(mCiclo) {
    try {
      const url = BASE_URL + '/multiplos-ciclos-entrega/cadastro'
      const response = await authHttp().post(url, mCiclo)
      return response.data
    } catch (e) {
      throw errorHandler(e)
    }
  },

  async getAll(centralId, pInicial, pFinal) {
    try {
      const dtInicial = parseToMysqlFormatWithTime(pInicial)
      const dtFinal = parseToMysqlFormatWithTime(pFinal)

      const url =
        BASE_URL +
        `/multiplos-ciclos-entrega/get-all?central_id=${centralId}&p_inicial=${dtInicial}&p_final=${dtFinal}`
      const response = await authHttp().get(url)

      return response.data
    } catch (e) {
      throw errorHandler(e)
    }
  },

  async apagar(mCicloId) {
    try {
      const url = BASE_URL + `/multiplos-ciclos-entrega/${mCicloId}`
      await authHttp().delete(url)
    } catch (e) {
      throw errorHandler(e)
    }
  },

  async getCiclosImportados(mCicloId) {
    try {
      const url = BASE_URL + `/multiplos-ciclos-entrega/ciclos-importados/${mCicloId}`
      const response = await authHttp().get(url)
      return response.data
    } catch (e) {
      throw errorHandler(e)
    }
  },

  async importar(content, mCicloId, userId) {
    try {
      const url = BASE_URL + `/multiplos-ciclos-entrega/importacao-danone/${mCicloId}/${userId}`
      const response = await authHttp().post(url, content)
      return response.data
    } catch (e) {
      throw errorHandler(e)
    }
  },

  async updateDataOperacao(cicleIdWithDate) {
    try {
      const url = BASE_URL + `/delivery-cycles/update/dataop`
      const response = await authHttp().put(url, { deliveriesCycles: cicleIdWithDate })
      return response.data
    } catch (e) {
      throw errorHandler(e)
    }
  },
}

export default MultiDeliveryCycleHttp
